// removed by extract-text-webpack-plugin
module.exports = {"modal":"src-components-Modal----modal-module---modal---VXcAj","show":"src-components-Modal----modal-module---show---29MIb","container":"src-components-Modal----modal-module---container---3fwTg","background":"src-components-Modal----modal-module---background---2C_gM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/modal.module.scss
// module id = 305
// module chunks = 168707334958949